import { Component, OnInit, inject } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { TranslocoService } from '@jsverse/transloco';
import { LanguageService } from './common/services/language.service';
import { AuthAppService } from './modules/auth';

@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.scss'],
    imports: [RouterOutlet],
})
export class AppComponent implements OnInit {
    private readonly authService = inject(AuthAppService);
    private readonly translocoService = inject(TranslocoService);
    private readonly languageService = inject(LanguageService);

    ngOnInit(): void {
        this.languageService.langChanged$.subscribe((lang) => {
            this.languageService.loadModuleLanguage(lang).then(() => {
                if (this.translocoService.getActiveLang() !== lang) {
                    this.translocoService.setActiveLang(lang);
                }
            });
        });
    }
}
